/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TutorialTagWithUsage } from './TutorialTagWithUsage';
import {
    TutorialTagWithUsageFromJSON,
    TutorialTagWithUsageFromJSONTyped,
    TutorialTagWithUsageToJSON,
    TutorialTagWithUsageToJSONTyped,
} from './TutorialTagWithUsage';

/**
 * Paginated response for the superadmin tag list.
 * @export
 * @interface PaginatedTutorialTagsResponse
 */
export interface PaginatedTutorialTagsResponse {
    /**
     * Tags on this page
     * @type {Array<TutorialTagWithUsage>}
     * @memberof PaginatedTutorialTagsResponse
     */
    items: Array<TutorialTagWithUsage>;
    /**
     * Total number of matching tags
     * @type {number}
     * @memberof PaginatedTutorialTagsResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedTutorialTagsResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedTutorialTagsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedTutorialTagsResponse interface.
 */
export function instanceOfPaginatedTutorialTagsResponse(value: object): value is PaginatedTutorialTagsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedTutorialTagsResponseFromJSON(json: any): PaginatedTutorialTagsResponse {
    return PaginatedTutorialTagsResponseFromJSONTyped(json, false);
}

export function PaginatedTutorialTagsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedTutorialTagsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TutorialTagWithUsageFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedTutorialTagsResponseToJSON(json: any): PaginatedTutorialTagsResponse {
    return PaginatedTutorialTagsResponseToJSONTyped(json, false);
}

export function PaginatedTutorialTagsResponseToJSONTyped(value?: PaginatedTutorialTagsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(TutorialTagWithUsageToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

